import { render, staticRenderFns } from "./fileTech3.vue?vue&type=template&id=189066b6&scoped=true&"
import script from "./fileTech3.vue?vue&type=script&lang=js&"
export * from "./fileTech3.vue?vue&type=script&lang=js&"
import style0 from "./fileTech3.vue?vue&type=style&index=0&id=189066b6&scoped=true&lang=css&"
import style1 from "./fileTech3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189066b6",
  null
  
)

export default component.exports